module.exports = __webpack_public_path__ + "static/media/sitebuilder_success_es.4dc1fc31.png";